<template>
  <div class="flex h-full w-full items-center justify-center">
    <div
      class="h-32 w-32 animate-spin rounded-full border-b-2 border-t-2 border-[#1e925d]"
    ></div>
  </div>
</template>
